import actions from "@/shared/actions";

export function sendGlobalInfo(info){
    actions.setGlobalState(info);
}
export function watchGlobalInfo(func,bool){
    actions.onGlobalStateChange(func,bool);
}